// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"48":"result-page","79":"processing-static-page","185":"widget-page","285":"redirect-page"}[chunkId] || chunkId) + "." + {"48":"0bad6a13","79":"dee45c9d","109":"ad204922","185":"b866d801","285":"7c567a04","666":"1e63ae20","974":"67172ae8"}[chunkId] + ".js";
};